import { Card } from "@/components/ui/card";

export const StatCard = ({ label, value, icon: Icon, accent = "text-slate-900", testid }) => (
  <Card data-testid={testid} className="p-5 border-slate-200 hover:shadow-md transition-shadow">
    <div className="flex items-center justify-between mb-2">
      <span className="text-xs uppercase tracking-[0.15em] font-semibold text-slate-500">{label}</span>
      {Icon && <Icon size={20} className="text-slate-400" weight="duotone" />}
    </div>
    <div className={`text-2xl sm:text-3xl font-semibold ${accent}`} style={{ fontFamily: "Outfit, sans-serif" }}>
      {value}
    </div>
  </Card>
);

export const SectionTitle = ({ children, action }) => (
  <div className="flex items-end justify-between mb-4">
    <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
      {children}
    </h2>
    {action}
  </div>
);

export const EmptyState = ({ title, description, action }) => (
  <div className="rounded-lg border border-dashed border-slate-300 p-10 text-center bg-white">
    <h3 className="text-base font-medium text-slate-900">{title}</h3>
    {description && <p className="mt-1 text-sm text-slate-500">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const PageHeader = ({ title, description, action }) => (
  <div className="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
    <div>
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>{title}</h1>
      {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
    </div>
    {action}
  </div>
);
